import type { PathConfig } from '@react-navigation/native';
import { groupMembersLinking } from 'app/screens/groups/group-members.linking';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/notifications',
  screens: {
    'all-notifications': '/all',
    'group-members': groupMembersLinking,
  },
};
